import {
  BodyText,
  Card,
  Flex,
  Heading,
  Link,
} from '@utilitywarehouse/hearth-react';
import { ChevronRightSmallIcon } from '@utilitywarehouse/hearth-react-icons';
import NeighborsCups from '@utilitywarehouse/hearth-svg-assets/lib/spot-neighbours-light.svg';

import './styles.scss';

const getPartnerRegistrationUrl = (token: string) =>
  `/partner/join/customer/${token}`;

const PartnerBanner = ({
  registrationToken,
}: {
  registrationToken: Nullable<string>;
}) => (
  <Card
    variant="subtle"
    colorScheme="brand"
    spacing="lg"
    direction={{ tablet: 'row', mobile: 'column' }}
    alignItems="center"
  >
    <img
      className="thankYou__coffee-cups"
      src={NeighborsCups}
      alt="Coffee cups"
    />
    <Flex
      direction="column"
      spacing="lg"
      justifyContent="between"
      alignItems={{ tablet: 'start', mobile: 'center' }}
      textAlign={{ tablet: 'left', mobile: 'center' }}
    >
      <Flex direction="column" spacing="sm">
        <Heading as="h3" size="sm">
          Earn up to £250 for each customer you switch
        </Heading>
        <BodyText>
          Complete a short form to become a Partner and we’ll give you all you
          need to get started.
        </BodyText>
      </Flex>
      <Link
        href={getPartnerRegistrationUrl(registrationToken!)}
        target="_blank"
        rel="noopener noreferrer"
        hideOpenIcon
      >
        Become a UW partner
        <ChevronRightSmallIcon />
      </Link>
    </Flex>
  </Card>
);

export { PartnerBanner };
